import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isEqual, isFunction, isVueComponent, cloneVNode, extractVNodeData } from '@cloud-sn/v-utils';
import Trigger from '@cloud-sn/v-trigger';
import Icon from '../icon';
import Menu from './menu';
import { buildComponentName } from '../utils';
import { DEFAULT_FIELD_NAMES, flatten, maybeAncestorOf } from './util';
import placements from './placements';
import StoreMixin from './mixins/store';
import AsyncMixin from './mixins/async';
export default {
  name: buildComponentName('MultiCascader'),
  mixins: [StoreMixin, AsyncMixin],
  props: {
    prefixCls: {
      type: String,
      default: 'ux-multi-cascader'
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadData: {
      type: Function,
      default: null
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    popupPlacement: {
      type: String,
      default: 'bottomLeft'
    },
    popupVisible: {
      type: Boolean,
      default: false
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'default', 'small', 'large'].indexOf(val) > -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    expandTrigger: {
      type: String,
      default: 'click',
      validator: function validator(val) {
        return ['hover', 'click'].indexOf(val) > -1;
      }
    },
    checkStrict: {
      type: Boolean,
      default: false
    },
    fieldNames: {
      type: Object,
      default: function _default() {
        return DEFAULT_FIELD_NAMES;
      }
    },
    transitionName: {
      type: String,
      default: 'slide-up'
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    displayRender: {
      type: Function,
      default: function _default(labels) {
        return labels.join(' / ');
      }
    },
    renderLabel: {
      type: Function,
      default: null
    },
    maxTagCount: {
      type: [Number, String],
      default: -1
    },
    maxTagPlaceholder: {
      type: [Function, String],
      default: null
    }
  },
  data: function data() {
    return {
      innerValue: [],
      // 当前选中节点，主要用于控制展示下一级数据
      activeValue: [],
      // 当前点击的复选框节点，用于判断异步数据加载后要不要触发事件
      activeCheckValue: [],
      innerVisible: false,
      focused: false,
      // 第一层节点
      rootNodes: []
    };
  },
  computed: {
    normalizedFieldNames: function normalizedFieldNames() {
      var fieldNames = this.fieldNames;
      return _objectSpread({}, DEFAULT_FIELD_NAMES, {}, fieldNames);
    },
    labelField: function labelField() {
      return this.normalizedFieldNames.label;
    },
    valueField: function valueField() {
      return this.normalizedFieldNames.value;
    },
    childrenField: function childrenField() {
      return this.normalizedFieldNames.children;
    },
    isLazy: function isLazy() {
      return isFunction(this.loadData);
    },
    activeNodes: function activeNodes() {
      var activeValue = this.activeValue,
          getAllNodesInPath = this.getAllNodesInPath;
      return getAllNodesInPath(activeValue);
    },
    showNodes: function showNodes() {
      var rootNodes = this.rootNodes,
          activeNodes = this.activeNodes,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign;
      var nodes = activeNodes.reduce(function (r, node) {
        // 每一层级获取下一级节点列表
        var children = node.children;

        if (isArray(children) && children.length > 0) {
          r.push(children);
        }

        return r;
      }, [rootNodes]);
      forceUpdateTriggerAlign();
      return nodes;
    },
    validValue: function validValue() {
      var value = this.value;
      return !isArray(value) ? [] : value.filter(function (val) {
        return isArray(val) && val.length > 0;
      });
    },
    flatNodes: function flatNodes() {
      var rootNodes = this.rootNodes;
      return flatten(rootNodes);
    },
    checkedAsValueNodes: function checkedAsValueNodes() {
      var flatNodes = this.flatNodes,
          checkStrict = this.checkStrict,
          isLazy = this.isLazy; // 异步加载模式需要把勾选状态的未加载过的父节点也作为值传出去

      return flatNodes.filter(function (_ref) {
        var isChecked = _ref.isChecked,
            isParent = _ref.isParent,
            isLoaded = _ref.isLoaded;
        var isPending = isLazy && !isLoaded;
        return isChecked && (checkStrict || !isParent || isPending);
      });
    },
    tags: function tags() {
      var flatNodes = this.flatNodes,
          checkStrict = this.checkStrict;
      return flatNodes.filter(function (_ref2) {
        var isChecked = _ref2.isChecked,
            isParent = _ref2.isParent;
        return isChecked && (checkStrict || !isParent);
      });
    },
    triggerClass: function triggerClass() {
      var _ref3;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          focused = this.focused,
          size = this.size;
      return _ref3 = {}, _defineProperty(_ref3, prefixCls, true), _defineProperty(_ref3, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_ref3, "".concat(prefixCls, "-focused"), focused), _defineProperty(_ref3, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _ref3;
    },
    arrowClass: function arrowClass() {
      var _ref4;

      var prefixCls = this.prefixCls,
          innerVisible = this.innerVisible;
      return _ref4 = {}, _defineProperty(_ref4, "".concat(prefixCls, "-arrow"), true), _defineProperty(_ref4, "".concat(prefixCls, "-arrow-expand"), innerVisible), _ref4;
    }
  },
  watch: {
    dataSource: function dataSource(nVal) {
      if (!isArray(nVal)) {
        return;
      }

      var clearNodesMap = this.clearNodesMap,
          createNodes = this.createNodes,
          updateActiveValue = this.updateActiveValue,
          validValue = this.validValue,
          isLazy = this.isLazy,
          setPendingValue = this.setPendingValue,
          checkPendingValue = this.checkPendingValue;
      clearNodesMap();
      setPendingValue(validValue);
      this.rootNodes = createNodes(nVal, null, 0);

      if (isLazy) {
        checkPendingValue();
      }

      updateActiveValue();
    },
    value: function value(nVal) {
      var resetCheckedValue = this.resetCheckedValue,
          innerValue = this.innerValue,
          validValue = this.validValue;

      if (!isEqual(nVal, innerValue)) {
        resetCheckedValue(validValue);
      }
    },
    popupVisible: function popupVisible(nVal, oVal) {
      if (nVal !== oVal) {
        this.setInnerVisible(nVal, true);
      }
    }
  },
  created: function created() {
    var _this = this;

    var validValue = this.validValue,
        isLazy = this.isLazy,
        popupVisible = this.popupVisible,
        loadRootNodes = this.loadRootNodes,
        setPendingValue = this.setPendingValue,
        setInnerVisible = this.setInnerVisible,
        updateActiveValue = this.updateActiveValue,
        checkPendingValue = this.checkPendingValue; // 将所有有效值都视作待确认值

    setPendingValue(validValue); // 加载根节点数据

    loadRootNodes().then(function () {
      _this.innerValue = validValue;

      if (isLazy) {
        // 初始数据可能直接从数据源获取，需要检查pendingValue有效性
        checkPendingValue();
      }

      updateActiveValue();
      setInnerVisible(popupVisible, true);
    });
  },
  methods: {
    loadRootNodes: function loadRootNodes() {
      var _this2 = this;

      var dataSource = this.dataSource,
          createNodes = this.createNodes,
          isLazy = this.isLazy,
          asyncNode = this.asyncNode;
      return new Promise(function (resolve) {
        if (isArray(dataSource) && dataSource.length > 0) {
          _this2.rootNodes = createNodes(dataSource, null, 0);
          resolve();
        } else if (isLazy) {
          asyncNode().then(function (nodes) {
            _this2.rootNodes = nodes || [];
            resolve();
          });
        } else {
          _this2.rootNodes = [];
          resolve();
        }
      });
    },
    getDisplayLabel: function getDisplayLabel(values) {
      var displayRender = this.displayRender,
          getAllNodesInPath = this.getAllNodesInPath;
      var nodes = getAllNodesInPath(values);
      return displayRender(nodes.map(function (node) {
        return node.label;
      }), nodes.map(function (node) {
        return _objectSpread({}, node);
      }));
    },
    forceUpdateTriggerAlign: function forceUpdateTriggerAlign() {
      var triggerRef = this.$refs.triggerRef,
          innerVisible = this.innerVisible;

      if (triggerRef && innerVisible) {
        this.$nextTick(function () {
          triggerRef.forcePopupAlign();
        });
      }
    },
    focus: function focus() {
      var triggerNodeRef = this.$refs.triggerNodeRef;

      if (triggerNodeRef) {
        triggerNodeRef.focus();
      }
    },
    blur: function blur() {
      var triggerNodeRef = this.$refs.triggerNodeRef;

      if (triggerNodeRef) {
        triggerNodeRef.blur();
      }
    },
    getAllNodesInPath: function getAllNodesInPath(valuePath) {
      var getNode = this.getNode;
      return !isArray(valuePath) ? [] : valuePath.map(function (value, i) {
        var path = valuePath.slice(0, i + 1);
        return getNode(path);
      }).filter(function (node) {
        return !!node;
      });
    },
    resetCheckedValue: function resetCheckedValue(validValue) {
      var flatNodes = this.flatNodes,
          checkNodeRelation = this.checkNodeRelation,
          getNode = this.getNode,
          isLazy = this.isLazy,
          isUnMatchedValuePending = this.isUnMatchedValuePending,
          setPendingValue = this.setPendingValue,
          getInnerValue = this.getInnerValue;
      var unMatchedValue = []; // 先取消原来勾选的节点

      flatNodes.forEach(function (node) {
        var nNode = node;
        var disabled = nNode.disabled,
            isChecked = nNode.isChecked;

        if (isChecked) {
          nNode.isChecked = false;
          nNode.isIndeterminate = false;

          if (!disabled) {
            checkNodeRelation(nNode);
          }
        }
      }); // 勾选上指定节点

      validValue.forEach(function (val) {
        var node = getNode(val);

        if (!node) {
          unMatchedValue.push(val);
        } else {
          var disabled = node.disabled;
          node.isChecked = true;
          node.isIndeterminate = false;

          if (!disabled) {
            checkNodeRelation(node);
          }
        }
      });
      var pendingValue = !isLazy ? [] : unMatchedValue.filter(function (val) {
        return isUnMatchedValuePending(val);
      });
      setPendingValue(pendingValue);
      this.innerValue = getInnerValue();
    },
    getInnerValue: function getInnerValue() {
      var checkedAsValueNodes = this.checkedAsValueNodes,
          isLazy = this.isLazy,
          getPendingValue = this.getPendingValue;
      var pendingValue = !isLazy ? [] : getPendingValue();
      return [].concat(_toConsumableArray(checkedAsValueNodes.map(function (node) {
        return node.valuePath;
      })), _toConsumableArray(pendingValue));
    },
    handleCheckedChange: function handleCheckedChange() {
      var tags = this.tags,
          getInnerValue = this.getInnerValue;
      var value = getInnerValue();
      var output = value.map(function (val) {
        return _toConsumableArray(val);
      });
      this.innerValue = value;
      this.$emit('input', output);
      this.$emit('change', output, _toConsumableArray(tags.map(function (tag) {
        return _objectSpread({}, tag);
      })));
    },
    setInnerVisible: function setInnerVisible(visible) {
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var innerVisible = this.innerVisible;

      if (innerVisible !== visible) {
        this.innerVisible = visible;
        this.focused = visible;

        if (!silent) {
          this.$emit('popup-visible-change', visible);
        }
      }
    },
    updateActiveValue: function updateActiveValue() {
      var tags = this.tags,
          activeValue = this.activeValue,
          getNode = this.getNode;

      if (activeValue.length === 0 || !getNode(activeValue)) {
        this.activeValue = tags.length > 0 ? tags[0].valuePath : [];
      } else {
        // 让展示节点强制刷新
        this.activeValue = _toConsumableArray(activeValue);
      }
    },
    handleMenuClick: function handleMenuClick(e, node) {
      var _this3 = this;

      var isClickCheckbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var canAsync = this.canAsync,
          asyncNode = this.asyncNode;
      var valuePath = node.valuePath;
      this.focused = true;
      this.activeValue = valuePath; // 如果点击的复选框，保存点击的节点,可能需要触发事件

      if (isClickCheckbox) {
        this.activeCheckValue = valuePath;
      }

      if (canAsync(node)) {
        asyncNode(node).then(function () {
          var activeCheckValue = _this3.activeCheckValue,
              innerValue = _this3.innerValue,
              getInnerValue = _this3.getInnerValue,
              handleCheckedChange = _this3.handleCheckedChange; // 当前请求还有效

          if (isEqual(activeCheckValue, valuePath) && !isEqual(innerValue, getInnerValue())) {
            handleCheckedChange();
          }
        });
      }
    },
    onMenuItemSelect: function onMenuItemSelect(e, node) {
      this.handleMenuClick(e, node, false);
    },
    onMenuItemCheck: function onMenuItemCheck(e, node) {
      var checkNodeRelation = this.checkNodeRelation,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign,
          checkStrict = this.checkStrict,
          isLazy = this.isLazy,
          getPendingValue = this.getPendingValue,
          setPendingValue = this.setPendingValue,
          handleCheckedChange = this.handleCheckedChange,
          handleMenuClick = this.handleMenuClick;
      var isChecked = node.isChecked,
          isParent = node.isParent,
          isLoaded = node.isLoaded,
          valuePath = node.valuePath;
      e.stopPropagation();
      checkNodeRelation(node);
      forceUpdateTriggerAlign(); // 非异步加载模式或节点已经加载过了，直接触发事件

      if (!isLazy || isLoaded) {
        handleCheckedChange();
      } // 异步加载模式父子关联场景取消勾选，需要把当前节点的后代元素从pendingValue中删除


      var pendingValue = getPendingValue();
      var len = pendingValue;

      if (isLazy && !checkStrict && !isChecked && isParent && pendingValue.length > 0) {
        pendingValue = pendingValue.filter(function (val) {
          return !maybeAncestorOf(valuePath, val);
        });

        if (len !== pendingValue.length) {
          setPendingValue(pendingValue);
        }
      } // 展示下级数据


      handleMenuClick(e, node, true);
    },
    onClear: function onClear(e) {
      var setInnerVisible = this.setInnerVisible,
          tags = this.tags,
          checkNodeRelation = this.checkNodeRelation,
          handleCheckedChange = this.handleCheckedChange;
      e.stopPropagation();
      tags.filter(function (tag) {
        return !tag.disabled;
      }).forEach(function (tag) {
        var node = tag;
        node.isChecked = false;
        checkNodeRelation(node);
      });
      setInnerVisible(false);
      handleCheckedChange();
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible);
    },
    onRemove: function onRemove(e, tag) {
      var forceUpdateTriggerAlign = this.forceUpdateTriggerAlign,
          checkNodeRelation = this.checkNodeRelation,
          handleCheckedChange = this.handleCheckedChange;
      e.stopPropagation();
      var node = tag;
      node.isChecked = false;
      checkNodeRelation(node);
      forceUpdateTriggerAlign();
      handleCheckedChange();
    },
    getSlotDefaultTriggerNode: function getSlotDefaultTriggerNode() {
      var h = this.$createElement;
      var slotDefault = this.$slots.default,
          disabled = this.disabled;
      var triggerNode = null;

      if (!slotDefault || !slotDefault[0]) {
        return triggerNode;
      }

      var slotNode = slotDefault[0];
      var slotNodeData = extractVNodeData(slotNode, isVueComponent(slotNode));
      return h("template", {
        "slot": "trigger"
      }, [cloneVNode(slotNode, {
        attrs: _objectSpread({}, slotNodeData.attrs, {
          tabindex: disabled ? undefined : 0
        })
      })]);
    },
    renderTags: function renderTags() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          tags = this.tags,
          disabled = this.disabled,
          onRemove = this.onRemove,
          getDisplayLabel = this.getDisplayLabel,
          maxTagCount = this.maxTagCount,
          maxTagPlaceholder = this.maxTagPlaceholder;
      var maxCount = Number(maxTagCount);
      var isTagsExceed = maxCount >= 0 && maxCount < tags.length;
      var shownTags = isTagsExceed ? tags.slice(0, maxCount) : tags;
      var extraTags = isTagsExceed ? tags.slice(maxCount) : [];
      var extraTag = null;

      if (isTagsExceed) {
        var placeholder = isFunction(maxTagPlaceholder) ? maxTagPlaceholder(extraTags) : maxTagPlaceholder;
        extraTag = h("li", {
          "class": "".concat(prefixCls, "-tag ").concat(prefixCls, "-tag-disabled")
        }, [h("div", {
          "class": "".concat(prefixCls, "-tag-content")
        }, [placeholder])]);
      }

      return tags.length > 0 ? h("ul", {
        "class": "".concat(prefixCls, "-tag-wrapper")
      }, [shownTags.map(function (tag) {
        var _tagCls;

        var tagCls = (_tagCls = {}, _defineProperty(_tagCls, "".concat(prefixCls, "-tag"), true), _defineProperty(_tagCls, "".concat(prefixCls, "-tag-disabled"), tag.disabled), _tagCls);
        var removeIcon = disabled || tag.disabled ? null : h(Icon, {
          "attrs": {
            "type": "close-t"
          },
          "class": "".concat(prefixCls, "-tag-remove"),
          "on": {
            "click": function click($event) {
              onRemove($event, tag);
            }
          }
        });
        return h("li", {
          "class": tagCls
        }, [h("div", {
          "class": "".concat(prefixCls, "-tag-content")
        }, [getDisplayLabel(tag.valuePath)]), removeIcon]);
      }), extraTag]) : null;
    },
    renderPlaceholder: function renderPlaceholder() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          tags = this.tags,
          placeholder = this.placeholder;
      return tags.length > 0 ? null : h("div", {
        "class": "".concat(prefixCls, "-placeholder")
      }, [placeholder]);
    },
    renderClearIcon: function renderClearIcon() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          allowClear = this.allowClear,
          disabled = this.disabled,
          tags = this.tags,
          onClear = this.onClear;
      return allowClear && !disabled && tags.length > 0 ? h(Icon, {
        "attrs": {
          "type": "close-circle-t"
        },
        "class": "".concat(prefixCls, "-clear"),
        "on": {
          "click": onClear
        }
      }) : null;
    },
    renderArrow: function renderArrow() {
      var h = this.$createElement;
      var arrowClass = this.arrowClass;
      return h(Icon, {
        "key": "arrow",
        "attrs": {
          "type": "down-a"
        },
        "class": arrowClass
      });
    },
    renderTrigger: function renderTrigger() {
      var h = this.$createElement;
      var disabled = this.disabled,
          triggerClass = this.triggerClass,
          getSlotDefaultTriggerNode = this.getSlotDefaultTriggerNode,
          renderTags = this.renderTags,
          renderPlaceholder = this.renderPlaceholder,
          renderArrow = this.renderArrow,
          renderClearIcon = this.renderClearIcon;
      var triggerNode = getSlotDefaultTriggerNode();

      if (!triggerNode) {
        triggerNode = h("div", {
          "slot": "trigger",
          "ref": "triggerNodeRef",
          "attrs": {
            "tabIndex": disabled ? undefined : 0
          },
          "class": triggerClass
        }, [renderPlaceholder(), renderTags(), renderClearIcon(), renderArrow()]);
      }

      return triggerNode;
    },
    renderPopup: function renderPopup() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          showNodes = this.showNodes,
          activeValue = this.activeValue,
          $scopedSlots = this.$scopedSlots,
          renderLabel = this.renderLabel,
          expandTrigger = this.expandTrigger,
          onMenuItemCheck = this.onMenuItemCheck,
          onMenuItemSelect = this.onMenuItemSelect;
      var renderLabelFn = $scopedSlots.renderLabel || renderLabel;
      return h("template", {
        "slot": "popup"
      }, [showNodes.map(function (nodes, i) {
        var menuProps = {
          prefixCls: prefixCls,
          nodes: nodes,
          // level: i,
          expandTrigger: expandTrigger,
          // 使用null避免undefined被menu设置默认值''影响判断
          activeValue: activeValue[i] !== undefined ? activeValue[i] : null,
          renderLabel: renderLabelFn
        };
        var on = {
          select: onMenuItemSelect,
          check: onMenuItemCheck
        };
        return h(Menu, {
          "props": _objectSpread({}, menuProps),
          "on": _objectSpread({}, on)
        });
      })]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        disabled = this.disabled,
        innerVisible = this.innerVisible,
        builtinPlacements = this.builtinPlacements,
        transitionName = this.transitionName,
        popupClass = this.popupClass,
        popupStyle = this.popupStyle,
        getPopupContainer = this.getPopupContainer,
        popupPlacement = this.popupPlacement,
        onPopupVisibleChange = this.onPopupVisibleChange,
        renderTrigger = this.renderTrigger,
        renderPopup = this.renderPopup;
    var triggerProps = {
      prefixCls: "".concat(prefixCls, "-panel"),
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      builtinPlacements: builtinPlacements,
      popupPlacement: popupPlacement,
      popupTransitionName: transitionName,
      popupClass: popupClass,
      popupStyle: popupStyle,
      getPopupContainer: getPopupContainer
    };
    var on = {
      'popup-visible-change': onPopupVisibleChange
    };
    return h(Trigger, _mergeJSXProps([{}, {
      props: triggerProps,
      ref: 'triggerRef',
      on: on
    }]), [renderTrigger(), renderPopup()]);
  }
};